import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgElasticIp = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-elastic-ip';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.36 3.281a8.4 8.4 0 0 0-3.22.879c-2.805 1.379-4.618 4.072-4.867 7.23-.138 1.749.34 3.688 1.28 5.203a9.1 9.1 0 0 0 2.854 2.854c1.515.94 3.454 1.418 5.203 1.28 2.157-.17 4.066-1.043 5.57-2.547s2.377-3.413 2.547-5.57c.214-2.713-.977-5.533-3.073-7.281-1.792-1.493-3.976-2.204-6.294-2.048m1.588 1.54a7.24 7.24 0 0 1 6.05 5.308 7.27 7.27 0 0 1-.947 5.851c-1.077 1.637-2.72 2.738-4.691 3.145-.404.084-.569.095-1.36.095s-.956-.011-1.36-.095c-1.975-.408-3.612-1.505-4.691-3.145a7.24 7.24 0 0 1-1.128-4.928 7.24 7.24 0 0 1 5.308-6.05 7.6 7.6 0 0 1 2.819-.181M9.811 8.278a.88.88 0 0 0-.481.374c-.065.118-.071.366-.081 3.26-.007 2.096.003 3.184.031 3.288a.743.743 0 0 0 1.245.325.8.8 0 0 0 .192-.314c.032-.118.042-1.081.034-3.299-.011-3.074-.013-3.135-.093-3.271a.81.81 0 0 0-.847-.363m2.609-.021a1 1 0 0 1-.149.04c-.147.032-.39.251-.457.411-.044.105-.054.726-.054 3.288 0 2.135.014 3.195.043 3.271.093.249.438.491.697.491s.604-.242.697-.491c.026-.067.043-.473.043-1.01v-.897l.49-.001c.592-.001.954-.071 1.336-.259a2.07 2.07 0 0 0 1.059-1.18c.089-.244.095-.314.095-1.12 0-.943-.019-1.051-.271-1.532-.227-.431-.758-.821-1.289-.947-.186-.044-2.149-.1-2.24-.064m2.071 1.593c.185.122.239.286.26.79.042 1.017-.115 1.2-1.03 1.2h-.481V9.752l.572.014c.462.011.592.027.679.084"
    })
  }));
});
export default SvgElasticIp;